/* global process */
import environment from '../environment/environment';

export const API_ENDPOINT = `${environment.API_URL}`;
export const API_PUBLIC_ENDPOINT = `${environment.API_URL.replace(/\/api([^\/api]*)$/, '$1')}`;
export const API_ENDPOINT_LEGACY = `${environment.API_URL_LEGACY}`;

export const OPERATIONS_URL = `${API_ENDPOINT}/operacoes`;
export const PRODUCT_URL = `${API_ENDPOINT}/operacoes/:id/detalhes`;
export const PRODUCT_URL_NEW_OPERATIONS = `${API_ENDPOINT}/tradeidea/:id/detalhes`;

export const NEW_OPERATIONS_PILOT = `${API_ENDPOINT}/tradeidea/authorization`;

export const MENU_URL = `${API_ENDPOINT}/operacoes/menuCategorizado`;

export const OPERATIONS_PAGINATION_URL = `${API_ENDPOINT}/Operacoes`;

export const QUOTE_ASSET_PRICE_URL = `${API_PUBLIC_ENDPOINT}/public/Cotacao`;
export const QUOTE_SAVED_URL = `${API_ENDPOINT}/EstruturaPrecoFavorito`;
export const QUOTE_ASSETS_URL = `${API_ENDPOINT}/EstruturaPreco/EstruturaAtivo`;
export const QUOTE_STUCTURES_URL = `${API_ENDPOINT}/EstruturaPreco/EstruturaTemplate`;
export const QUOTE_STUCTURE_PRICE_URL = `${API_ENDPOINT}/EstruturaPreco/EstruturaPreco`;

export const CREATE_OPERATION_URL = `${API_ENDPOINT}/montarOperacoes`;
export const QUOTE_OPERATION_URL = `${API_ENDPOINT}/montarOperacoes/detalhes`;
export const VALIDATE_PRICE_OPERATION_URL = `${API_ENDPOINT}/montarOperacoes/validar-precos`;
export const CREATE_OPERATION_FILTERS_URL = `${API_ENDPOINT}/montarOperacoes/filtros`;

export const CUSTOMER_URL = `${API_ENDPOINT}/clientes`;
export const FAVORITE_CUSTOMER_URL = `${API_ENDPOINT}/clientes/favoritar`;

export const CANCEL_PROPOSALS_URL = `${API_ENDPOINT}/propostas/cancelar`;
export const SEND_PROPOSALS_URL = `${API_ENDPOINT}/propostas/enviar`;
export const VALIDATE_PROPOSALS_URL = `${API_ENDPOINT}/propostas/validar`;
export const PROPOSALS_URL = `${API_ENDPOINT}/propostas`;
export const CANCEL_NEW_PROPOSALS_URL = `${API_ENDPOINT}/tradeidea/{codigoOrdem}/cancelar`;

export const SEND_PROPOSALS_URL_RUBI_YIELD = `${API_ENDPOINT}/tradeIdea/{tradeIdeaId}/novaOperacao`;


export const LOAD_CACHE_LOGIN_URL = `${API_ENDPOINT}/Login/CarregarCacheLogin`;

export const OLD_PUSH_URL = `${API_ENDPOINT_LEGACY}-public/push`;
export const NEW_PUSH_URL = `${environment.API_URL_PUSH}/public/push`;
export const PUSH_URL = `${API_PUBLIC_ENDPOINT}/public/Push/novaLamina`;

export const ADVISOR_ENABLES_REPORT_URL = `${API_ENDPOINT}/Relatorio/AssessoresPermitidosRelatorio`;

export const REPORT_POSITION_URL = `${API_ENDPOINT}/Relatorio/RelatorioPosicao`;
export const REPORT_COMMISSION_URL = `${API_ENDPOINT}/Relatorio/RelatorioComissao`;
export const REPORT_BARRIER_BEAT_URL = `${API_ENDPOINT}/Relatorio/RelatorioBatimentoBarreira`;
export const REPORT_OPERATIONS_URL = `${API_ENDPOINT}/Relatorio/RelatorioOperacoesExecutadas`;
export const REPORT_FIXING_ASSET_URL = `${API_ENDPOINT}/Relatorio/RelatorioFixingComAtivo`;
export const REPORT_FIXING_NO_ASSET_URL = `${API_ENDPOINT}/Relatorio/RelatorioFixingSemAtivo`;

export const CMS_URL = 'https://cms-xp-preprod.go-vip.net/shield/wp-json/xpshield/v1';
export const CMS_PRODUCT_URL = `${CMS_URL}/product`;

export const POWER_BI_URL = `${API_ENDPOINT}/PowerBI`;

export const NOTIFICATION_URL = `${API_ENDPOINT}/Mensageria?TamanhoPagina=10`;
export const NOTIFICATION_PILOT = `${API_ENDPOINT}/Mensageria/Authorization`;

export const CURRENT_NOTIFICATION = `${API_ENDPOINT}/Mensageria/{guid}`;
